import {
  IReportDraftDomain,
  IWorkflowItemStep,
} from '../../../../common/sharedTypes';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as urls from '../../../shared/urls';

export enum ViewTvalActionTypes {
  VIEW_TVAL_GET_FORM_DATA = '@@viewTval/VIEW_TVAL_GET_FORM_DATA',
}

export const getFormData = (reportId: number) => {
  return async (dispatch) => {
    try {
      await Api.get(
        `${urls.GET_REPORT_DRAFT_BY_REPORT_ID}?reportId=${reportId}`
      ).then((response: ApiResponse<any>) => {
        dispatch(setFormData(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const setFormData = (data: IReportDraftDomain) => {
  localStorage.setItem('viewTvalData', data.reportValidationData);
  return {
    type: ViewTvalActionTypes.VIEW_TVAL_GET_FORM_DATA,
    value: data.reportValidationData,
  };
};
